import { injectable } from "inversify";
import { Endpoints } from "../shared/enum";

@injectable()
export class SaveGameService {
    async deleteSave(saveId: string): Promise<void> {
        const url = `${Endpoints.BASE_URL}/${Endpoints.GAME_STATE}/save/${saveId}`;
        const response = await fetch(url, {
            method: "DELETE",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
        });

        if (response.status === 404) throw new Error("Save not found");
        if (response.status === 403) throw new Error("Permission denied");
        if (!response.ok) throw new Error(`Failed to delete: ${response.status}`);
    }
}
